import { KText } from '@/ui-library/components/text';
import { Flex, Avatar, Tooltip } from '@chakra-ui/react';

export const SubmittedUserName = ({ userName, userAvatar }) => {
  return (
    <Flex gap="6px" alignItems="center">
      <KText size="sm-medium" color="secondary-500" whiteSpace="nowrap">
        (filled by
      </KText>
      <Tooltip label={userName} variant="default" placement="bottom">
        <Avatar name={userName} src={userAvatar} borderRadius="8px" size="xs" />
      </Tooltip>
      <KText size="sm-medium" color="secondary-500" whiteSpace="nowrap">
        )
      </KText>
    </Flex>
  );
};
